<template>
  <div>
    <div class="back" v-if="isVisible" @click="hideModal"></div>
    <div class="authCodeDialog" v-if="isVisible">
      <div class="modalView_pop">
        <div class="modalView_pop_header">
          <div class="modalView_pop_header_title">{{ $t('authCode.title') }}</div>
        </div>
        
        <div class="modalView_pop_content">
          <div class="modalView_pop_content_form">
            <el-form :model="authForm" :rules="authRules" ref="authForm" label-width="120px">
              <el-form-item :label="$t('authCode.code')" prop="authCode">
                <el-input
                  v-model="authForm.authCode"
                  :placeholder="$t('authCode.placeholder')"
                  clearable
                ></el-input>
              </el-form-item>
              
              <div v-if="authResult" class="auth-result" :class="{ success: authResult.success, error: !authResult.success }">
                <i v-if="authResult.success" class="el-icon-success"></i>
                <i v-else class="el-icon-error"></i>
                <span>{{ authResult.message }}</span>
              </div>
              
              <div v-if="authInfo" class="auth-info">
                <div class="auth-info-title">{{ $t('authCode.infoTitle') }}</div>
                <el-table :data="authInfoItems" border size="small" class="auth-info-table">
                  <el-table-column prop="label" :label="$t('authCode.infoLabel')" width="120"></el-table-column>
                  <el-table-column prop="value" :label="$t('authCode.infoValue')"></el-table-column>
                </el-table>
              </div>
            </el-form>
          </div>
        </div>
        
        <div class="modalView_pop_footer">
          <el-button @click="hideModal">{{ $t('authCode.cancel') }}</el-button>
          <el-button type="primary" @click="checkAuthCode" :loading="checking">
            {{ $t('authCode.check') }}
          </el-button>
          <el-button 
            type="success" 
            @click="activateAuthCode" 
            :loading="activating" 
            :disabled="!canActivate"
          >
            {{ $t('authCode.activate') }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryAuthCode, activateCode } from '@/api/index';
export default {
  name: 'CodeDialog',
  data() {
    return {
      authForm: {
        authCode: ''
      },
      authRules: {
        authCode: [
          { required: true, message: this.$t('authCode.required'), trigger: 'blur' },
          { min: 8, max: 32, message: this.$t('authCode.length'), trigger: 'blur' }
        ]
      },
      authResult: null,
      authInfo: null,
      checking: false,
      activating: false,
      authInfoItems: [],
      isVisible: false
    };
  },
  computed: {
    canActivate() {
      return this.authResult && this.authResult.success && !this.activating;
    }
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        // 重置表单当弹窗打开时
        this.resetForm();
      }
    }
  },
  methods: {
    // 显示弹窗
    showModal() {
        this.isVisible = true; // 假设 isVisible 控制弹窗的显示状态
        document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },

    // 隐藏弹窗
    hideModal() {
        this.resetForm();
        this.isVisible = false;
    },
    
    // 重置表单和状态
    resetForm() {
        this.authForm.authCode = '';
        this.authResult = null;
        this.authInfo = null;
        this.authInfoItems = [];
        this.checking = false;
        this.activating = false;
        if (this.$refs.authForm) {
            this.$refs.authForm.resetFields();
        }
    },
    
    // 查询授权码
    checkAuthCode() {
      this.$refs.authForm.validate((valid) => {
        if (valid) {
          this.checking = true;
          queryAuthCode(this.authForm.authCode).then(res => {
            if (res.data.code === 200 && res.data.data.status === "not_activated") {
              this.authResult = {
                success: true,
                message: this.$t('authCode.valid')
              };            
              this.authInfo = {
                code: this.authForm.authCode,
                productName: res.data.data.license_payload.feature_code === 'tpc' ? this.$t('serviceI18n.tpc') : this.$t('serviceI18n.tzj'),
                scope: res.data.data.license_payload.scope,
                address_limit: res.data.data.license_payload.address_limit,
                source_limit: res.data.data.license_payload.source_limit,
              };
              // 格式化授权信息为表格数据
              this.authInfoItems = [
                { label: this.$t('authCode.package_spec'), value: res.data.data.service_package.package_spec },
                { label: this.$t('authCode.channel'), value: res.data.data.reseller.reseller_name },
                { label: this.$t('authCode.channelOrderId'), value: res.data.data.reseller_order_id },
                { label: this.$t('authCode.product'), value: this.authInfo.productName },
                { 
                  label: this.$t('authCode.scope'), 
                  value: this.authInfo.scope == 0 ? this.$t('orderI18n.scope_list[0].name') : this.$t('orderI18n.scope_list[1].name')
                },
                { 
                  label: this.$t('authCode.address_limit'), 
                  value: res.data.data.license_payload.address_limit == 2 ? "≤2" : res.data.data.license_payload.address_limit == 4 ? "≤4" : res.data.data.license_payload.address_limit == 30 ? "≤30" : res.data.data.license_payload.address_limit
                },
                { 
                  label: this.$t('authCode.source_limit'), 
                  value: res.data.data.license_payload.source_limit == 0 ? "≤100" : res.data.data.license_payload.source_limit == 1 ? "≤500" : res.data.data.license_payload.source_limit == 2 ? ">500" : res.data.data.license_payload.source_limit == 10 ? "≤20" : ""
                }
              ];
              this.checking = false;
            } else if(res.data.code === 1001){
              this.authResult = {
                success: false,
                message: "授权码不存在"
              };
              this.authInfo = null;
              this.authInfoItems = [];
              this.checking = false;
            } else if(res.data.code === 1002){
              this.authResult = {
                success: false,
                message: "权码已过期,请联系客服邮箱customerservice@carbonneutrality-group.com"
              };
              this.authInfo = null;
              this.authInfoItems = [];
              this.checking = false;
            }else {
              this.authResult = {
                success: false,
                message: this.$t('authCode.invalid')
              };
              this.authInfo = null;
              this.authInfoItems = [];
              this.checking = false;
            }
          }).catch(err => {
            this.$message({
              title: this.$t('authCode.error'),
              message: err.message || this.$t('authCode.error'),
              type: 'error',
              duration: 3000
            });
            this.checking = false;
          });
          
          /* 模拟失败响应的代码
          setTimeout(() => {
            this.authResult = {
              success: false,
              message: this.$t('authCode.invalid')
            };
            this.authInfo = null;
            this.authInfoItems = [];
            this.checking = false;
          }, 1500);
          */
        }
      });
    },
    
    // 激活授权码
    activateAuthCode() {
      if (!this.canActivate) return;
      this.activating = true;
      setTimeout(() => {
        activateCode(this.authForm.authCode).then(res => {
          if (res.data.code === 200) {
            this.$message({
              title: this.$t('authCode.success'),
              message: this.$t('authCode.activateSuccess'),
              type: 'success',
              duration: 3000
            });
            setTimeout(() => {
              this.hideModal();
              this.$emit('activated', this.authInfo);
            }, 1500);
            this.activating = false;
          } else {
            this.$message({
              title: this.$t('authCode.activateFailed'),
              message: res.data.msg || this.$t('authCode.activateFailed'),
              type: 'error',
              duration: 3000
            });
            this.activating = false;
          }
        }).catch(err => {
          this.$message({
            title: this.$t('authCode.activateFailed'),
            message: err.message || this.$t('authCode.activateFailed'),
            type: 'error',
            duration: 3000
          });
          this.activating = false;
        });
      }, 2000);
    }
  }
};
</script>

<style scoped lang="scss">
.back {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(33, 33, 33, 0.5);
  z-index: 1001;
}

.authCodeDialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 600px;
  max-width: 90vw;
  z-index: 1002;
  overflow: hidden;
  
  .modalView_pop_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid #e8e8e8;
    
    .modalView_pop_header_title {
      font-size: 18px;
      font-weight: 600;
      color: #333333;
    }
    
    .modalView_pop_header_close {
      cursor: pointer;
      color: #999999;
      font-size: 16px;
      &:hover {
        color: #666666;
      }
    }
  }
  
  .modalView_pop_content {
    padding: 24px;
    
    .modalView_pop_content_logo {
      display: flex;
      justify-content: center;
      margin-bottom: 24px;
      
      img {
        width: 80px;
        height: 80px;
        object-fit: contain;
      }
    }
    
    .modalView_pop_content_form {
      
      .auth-result {
        margin: 16px 0;
        padding: 12px 16px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        
        i {
          margin-right: 8px;
          font-size: 16px;
        }
        
        &.success {
          background-color: #f0f9eb;
          color: #67c23a;
          border: 1px solid #e1f3d8;
        }
        
        &.error {
          background-color: #fef0f0;
          color: #f56c6c;
          border: 1px solid #fbc4c4;
        }
      }
      
      .auth-info {
        margin: 16px 0;
        
        .auth-info-title {
          font-size: 14px;
          font-weight: 500;
          color: #606266;
          margin-bottom: 12px;
        }
        
        .auth-info-table {
          
          th {
            background-color: #fafafa;
            font-weight: 500;
          }
          
          td {
            color: #606266;
          }
        }
      }
    }
  }
  
  .modalView_pop_footer {
    display: flex;
    justify-content: flex-end;
    padding: 16px 24px;
    border-top: 1px solid #e8e8e8;
    background-color: #fafafa;
    
    button {
      margin-left: 12px;
    }
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .authCodeDialog {
    width: 95vw;
    top: 20px;
    transform: translateX(-50%);
    max-height: calc(100vh - 40px);
    overflow-y: auto;
  }
}
</style>